<template>
  <div :class="['social-bar']">
    <ul>
      <li v-for="(service, index) in services" :key="index">
        <a
          @click.prevent="popup(service.url(url, title()))"
          :href="service.url(url, title())"
          :title="firstLetterCapital(service.icon)">
          <i :class="['mdi', `mdi-${service.icon}`]" aria-hidden="true" :style="{fontSize: `${fontSize}em`}" />
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import services from '../helpers/social-bar-services'
import {title} from '../../package'

export default {
  name: 'SocialBar',
  data () {
    return {
      services,
      url: window.location.href,
      popupWidth: 640,
      popupHeight: 480
    }
  },
  props: {
    /**
     * Icon CSS font-size in em units
     */
    fontSize: {
      type: Number,
      default: 1.5
    }
  },
  methods: {
    /**
     * Generate app title by package.json fields
     * @method title
     * @return {string}
     */
    title () {
      return title
    },
    /**
     * Capitalize the first letter of a string
     * @method capitalize
     * @param {number} index
     * @return {string}
     */
    firstLetterCapital (string) {
      if (typeof string !== 'string') {
        return ''
      }
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    /**
     * Open url in a popup
     * @method popup
     * @param {string} url
     * @param {string} title
     * @param {number} width
     * @param {number} height
     * @return {object}
     */
    popup (url = window.location.href, title = '', width = 640, height = 480) {
      const left = (screen.width / 2) - (width / 2)
      const top = (screen.height / 2) - (height / 2)
      return window.open(url, title, `width=${width}, height=${height}, top=${top}, left=${left}, toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no`)
    }
  }
}
</script>
<style>
.social-bar,
.social-bar ul,
.social-bar li
{
  margin: 0;
  padding: 0;
  list-style: none;
}

.social-bar
{
  position: fixed;
  z-index: 5;
  top: 50%;
  left: .25em;
  transform: translate(0, -50%);
  filter: drop-shadow(0 0 .2em #000);
  background: rgba(0, 0, 0, .5);
  border-radius: 2px;
  backdrop-filter: blur(6px);
  border: solid 2px #ccc;
}

.social-bar a
{
  color: #ccc;
  transition: all .5s cubic-bezier(0.680, -0.550, 0.265, 1.550);
  display: block;
  padding: .25em;
}
</style>



// WEBPACK FOOTER //
// social-bar.vue?f1f5c726